/* @generated */
import * as React from "react";
import cx from "classnames";
import { normalizeResponsiveValue, mapResponsiveValue } from "../config/atoms.css.esm.js";
import { splitStyle, directionVariants, splitStyleFlexboxGap, xsGap, sGap, mGap, lGap, xlGap } from "./split.css.esm.js";
import { spacing } from "../config/spacing.esm.js";
import { getResponsiveStyling, ALIGN_X_TO_FLEX_ALIGN, walkByBreakpoint, ALIGN_Y_TO_FLEX_ALIGN } from "../config/responsive.esm.js";
import { resolveResponsivePropToClassName } from "../config/resolveResponsivePropToClassNames.esm.js";
import { FlexGapContext } from "./context.esm.js";
/* empty css                 */import { Box } from "../box/box.esm.js";
const GAP_VAR_MAPPING = {
  xsmall: xsGap,
  small: sGap,
  medium: mGap,
  large: lGap,
  xlarge: xlGap
};
const Split = ({
  children,
  alignX = "left",
  alignY = "top",
  wrap,
  gap,
  direction = "horizontal",
  className,
  display,
  style,
  height,
  width,
  isFlexGap = true,
  ...rest
}) => {
  const [responsiveGapClasses, gapVarsStyle] = getResponsiveStyling({
    styleProps: gap,
    varMap: spacing,
    sizeToStylingMapping: GAP_VAR_MAPPING
  });
  const styl = { ...style, ...gapVarsStyle };
  const justifyContent = normalizeResponsiveValue(
    mapResponsiveValue(alignX, (value) => ALIGN_X_TO_FLEX_ALIGN[value])
  );
  const alignItems = walkByBreakpoint(
    normalizeResponsiveValue(mapResponsiveValue(alignY, (value) => ALIGN_Y_TO_FLEX_ALIGN[value])),
    "flex-start"
  );
  return (
    // Note that `isFlexGap` here is always from the prop value and not optionally from context.
    // This is to ensure setting a `Split` to use flex gap will not cause spooky changes to distant `Split`s.
    /* @__PURE__ */ React.createElement(FlexGapContext.Provider, { value: { isFlexGap } }, /* @__PURE__ */ React.createElement(
      Box,
      {
        tagName: "span",
        display: display ? display : "block",
        height,
        width,
        ...rest,
        className: cx(className, {
          [splitStyle]: !isFlexGap
        })
      },
      /* @__PURE__ */ React.createElement(
        Box,
        {
          tagName: "span",
          display: "flex",
          justifyContent,
          flexWrap: wrap,
          style: styl,
          height,
          width,
          className: cx(
            responsiveGapClasses,
            resolveResponsivePropToClassName(
              direction,
              directionVariants.xsmall[alignItems.xsmall],
              directionVariants.small[alignItems.small],
              directionVariants.medium[alignItems.medium],
              directionVariants.large[alignItems.large],
              directionVariants.xlarge[alignItems.xlarge]
            ),
            {
              [splitStyleFlexboxGap]: isFlexGap === true
            }
          )
        },
        children
      )
    ))
  );
};
export {
  Split
};
